import { useCallback } from 'react';

import { RecurringSubscriptionData, SubscriptionOrderData } from 'chaika-frontend-types/frontend-cms';

import { useRecurringSubscriptions } from '@store/RecurringSubscription/hooks/useRecurringSubscriptions';

import { useDataLoading } from '@utils/hooks/useDataLoading';

import { subscriptionOrderStore } from '@modules/patient/ui/EhrPage/pages/SubscriptionOrderPage/store/SubscriptionOrderStore';
import { subscriptionOrderService } from '@modules/patient/ui/EhrPage/pages/SubscriptionOrderPage/services/SubscriptionOrderService';

interface Params {
    patientId: string;
}

interface Options {
    subscriptionOrders: SubscriptionOrderData[];
    recurringSubscriptions: RecurringSubscriptionData[];
    reload(): Promise<void>;
}

export const useSubscriptions = ({ patientId }: Params): Options => {
    const { data: recurringSubscriptions, refetch } = useRecurringSubscriptions(
        { patientId },
        { staleTime: Infinity, enabled: !!patientId },
    );

    const reload = useCallback(async () => {
        if (!!patientId) {
            await Promise.all([subscriptionOrderService.reload({ patientId }), refetch()]);
        }
    }, [patientId, refetch]);

    useDataLoading(async () => {
        if (!!patientId) {
            await subscriptionOrderService.reload({ patientId });
        }
    }, [patientId]);

    const subscriptionOrders = subscriptionOrderStore.getByPatientId(patientId);

    return {
        subscriptionOrders,
        recurringSubscriptions: recurringSubscriptions ?? [],
        reload,
    };
};
